module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "card-wrapper",
    class: {
      'invisible': _vm.viewBack,
      'visible': !_vm.viewBack
    }
  }, [_c('section', {
    staticClass: "front card",
    style: ({
      backgroundColor: _vm.color
    })
  }, [_c('div', {
    staticClass: "front"
  }, [_vm._t("header"), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("frontContent")], 2), _vm._v(" "), _c('div', {
    staticClass: "flipper no-select",
    on: {
      "click": function($event) {
        _vm.viewBack = !_vm.viewBack
      }
    }
  }, [_c('div', {
    staticClass: "in-flipper"
  }, [_vm._v("Click / Tap to flip!")]), _vm._v(" "), _c('Tooltip', [_vm._v("↑ or ↓")])], 1)], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "card-wrapper",
    class: {
      'visible': _vm.viewBack,
      'invisible': !_vm.viewBack
    }
  }, [_c('section', {
    staticClass: "back card",
    style: ({
      backgroundColor: _vm.color
    })
  }, [_c('div', {
    staticClass: "back"
  }, [_vm._t("headerBack"), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("backContent")], 2), _vm._v(" "), _c('div', {
    staticClass: "flipper no-select",
    on: {
      "click": function($event) {
        _vm.viewBack = !_vm.viewBack
      }
    }
  }, [_c('div', {
    staticClass: "in-flipper"
  }, [_vm._v("Click / Tap to flip!")])])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f449128","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cardview.vue
// module id = 284
// module chunks = 1